import { createEvent, restore, sample } from 'effector'
import { CreateSection } from './types'
import { fx, path } from '../../../../libs'
import { getSectionList } from '../../sections/list/model'
import { toPath } from '../../../../features/router'
import { createBudgetItem } from '../../budgetItem/create/model'

export const setSection = createEvent<CreateSection>()

export const submitCreateSection = createEvent<CreateSection>()

export const sectionListForSelectMounted = createEvent()

export const $section = restore(setSection, {
  name: '',
})

export const createSection = fx<CreateSection, void>({
  method: 'POST',
  url: '/finance/section',
})

sample({
  clock: submitCreateSection,
  fn: (budgetItem) => {
    return {
      url: `/finance/section`,
      body: { ...budgetItem },
    }
  },
  target: createSection,
})

sample({
  clock: sectionListForSelectMounted,
  fn: () => ({}),
  target: getSectionList,
})

sample({
  clock: [createSection.doneData],
  target: toPath.prepend(path.finSystem.sections.entry),
})
